export * from './catalog-list.component';
export * from './catalog-list-binding.directive';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/catalog/catalog-list/index.ts